import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderDropdown from './HeaderDropdown';
import logo from '../Images/mini_logo.svg';
import { useForm } from 'react-hook-form';
import MudarProjeto from './MudarProjeto';
import Notificacoes from './Notificacoes';
import HeaderItem from './HeaderItem';
import Impressao from './Impressao';
import MudarCd from './MudarCd';
import axios from 'axios';
import './Header.css';

const urlServer = process.env.REACT_APP_SERVIDOR;
let usuario = '';
let token = '';
let cd = '';

function Header() {

    const [newProjeto, setNewProjeto] = useState(null);
    const [acessos, setAcessos] = useState([]);
    const filtroProjeto = useForm();
    const navigate = useNavigate();
    const filtroCd = useForm();
    const navRef = useRef();

    useEffect(() => {
        token = sessionStorage.getItem('token');
        cd =
            JSON.parse(sessionStorage.getItem('user')).cod_cd ||
            JSON.parse(sessionStorage.getItem('cd')).cod_cd;
        usuario =
            JSON.parse(sessionStorage.getItem('user')).cod_usuario ||
            JSON.parse(sessionStorage.getItem('projeto')).usuario;
        pushAccess();
    }, []);

    useEffect(() => {
        acessos.length && sessionStorage.setItem('perfil', acessos[0].perfil);
    }, [acessos]);

    const pushAccess = useCallback(() => {
        axios.post(`${urlServer}/user/access`, { usuario, cd }, { headers: { 'Authorization': `Bearer ${token}` } })
            .then(resp => {
                setAcessos(resp.data.userAccess.acessos);
                sessionStorage.setItem('armazem_geral', resp.data.userAccess.eAG[0].armazem_geral);
            })
            .catch(console.log);
    }, []);

    const goLogin = useCallback(() => {
        sessionStorage.clear();
        window.location.reload();
    }, []);

    const handleNavigate = useCallback((e, url) => {
        navigate(url);
        document.activeElement.blur();
    }, []);

    const handleClickChangeProjeto = useCallback(() => {
        filtroProjeto.setValue('filtro', '');
        setTimeout(() => filtroProjeto.setFocus('filtro'), 500);
    }, []);

    const handleClickChangeCd = useCallback(() => {
        setNewProjeto(null);
        filtroCd.setValue('filtro', '');
        setTimeout(() => filtroCd.setFocus('filtro'), 500);
    }, []);

    return (
        <>
            <MudarProjeto setNewProjeto={setNewProjeto} filtro={filtroProjeto} filtroCd={filtroCd} />
            <MudarCd newProjeto={newProjeto} filtro={filtroCd} />
            <header id='main-header' >
                <img src={logo} alt='Logo Controll Mob' id='logo-header' onClick={e => handleNavigate(e, '/inicio')} />
                <nav id='main-nav' ref={navRef} >
                    <button className='main-nav-button' onClick={e => handleNavigate(e, '/inicio')}>
                        <i className='bi bi-house-fill me-1'></i>
                        Início
                    </button>
                    <div>
                        <button className='main-nav-button cb-dropdown'>
                            <i className='bi bi-person-fill-add me-1'></i>
                            Cadastro
                        </button>
                        <ul>
                            <HeaderDropdown label='Armazenagem' >
                                <HeaderItem acesso={317} route={'/cadastro/canteiros'} nome='Canteiros' handleNavigate={handleNavigate} />
                                <HeaderDropdown label='Endereços' >
                                    <HeaderItem acesso={323} route={'/cadastro/endereco-compartimento'} nome='Compartimento' handleNavigate={handleNavigate} />
                                    <HeaderItem acesso={322} route={'/cadastro/depositos'} nome='Depósitos' handleNavigate={handleNavigate} />
                                    <HeaderItem acesso={26} route={'/cadastro/enderecos'} nome='Endereços' handleNavigate={handleNavigate} />
                                    <HeaderItem acesso={49} route={'/cadastro/endereco-produto'} nome='Endereço Produto' handleNavigate={handleNavigate} />
                                    <HeaderItem acesso={324} route={'/cadastro/endereco-rua'} nome='Rua' handleNavigate={handleNavigate} />
                                </HeaderDropdown>
                                <HeaderItem acesso={51} route={'/cadastro/motivo-item-pedido'} nome='Motivo Item Pedido' handleNavigate={handleNavigate} />
                                <HeaderDropdown label='Produtos'>
                                    <HeaderItem acesso={24} route={'/cadastro/grupos-produtos'} nome='Grupo Produto' handleNavigate={handleNavigate} />
                                    <HeaderItem acesso={18} route={'/cadastro/produtos'} nome='Produtos' handleNavigate={handleNavigate} />
                                    <HeaderItem acessos={acessos} acesso={325} route={'/cadastro/produto-familia'} nome='Produtos Família' handleNavigate={handleNavigate} />
                                </HeaderDropdown>
                                <HeaderItem acesso={61} route={'/cadastro/situacoes'} nome='Situações' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={311} route={'/cadastro/tratamento'} nome='Tratamentos' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                            <HeaderDropdown label='Geral' >
                                <HeaderItem acesso={306} route={'/cadastro/acessos'} nome='Acessos' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={352} route={'/cadastro/bancos'} nome='Bancos' handleNavigate={handleNavigate}/>
                                <HeaderItem acesso={79} route={'/cadastro/cidades'} nome='Cidades' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={53} route={'/cadastro/contatos'} nome='Contatos' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={53} route={'/cadastro/email'} nome='Email' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={307} route={'/cadastro/empresas'} nome='Empresas' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={19} route={'/cadastro/pessoas'} nome='Pessoas' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={318} route={'/cadastro/regional'} nome='Regional' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={309} route={'/cadastro/tipos-nota-fiscal'} nome='Tipos NF' handleNavigate={handleNavigate} />         
                            </HeaderDropdown>
                            <HeaderDropdown label='Sementeira'>
                                <HeaderItem acesso={330} route={'/cadastro/campo'} nome='Campo' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={340} route={'/cadastro/config-umidade'} nome='Configurações de Umidade' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={343} route={'/cadastro/icms'} nome='ICMS UF' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={332} route={'/cadastro/moega'} nome='Moega' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={351} route={'/cadastro/qualidade'} nome='Qualidade' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={341} route={'/cadastro/safra'} nome='Safra' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={333} route={'/cadastro/situacao-carga'} nome='Situação Carga' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={337} route={'/cadastro/status-carga'} nome='Status Carga' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={334} route={'/cadastro/tipo-descarga-moega'} nome='Tipo Descarga' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={347} route={'/cadastro/tipo-pedido-master'} nome='Tipo Pedido Master' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={335} route={'/cadastro/tipo-veiculo'} nome='Tipo Veículo' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                            <HeaderDropdown label='Usuarios'>
                                <HeaderItem acesso={321} route={'/cadastro/tipo-usuario'} nome='Tipo Usuário' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={16} route={'/cadastro/usuario'} nome='Usuários' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                        </ul>
                    </div>
                    <div>
                        <button className='main-nav-button cb-dropdown'>
                            <i className='bi bi-file-earmark-plus-fill me-1'></i>
                            Lançamento
                        </button>
                        <ul>
                            <HeaderDropdown label='Armazenagem' acessos={acessos}>
                                <HeaderItem acesso={38} route={'/lancamento/alteracao-etiqueta'} nome='Alterar Dados Etiqueta' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={320} route={'/lancamento/alterar-produto-saldo'} nome='Alterar Produto Com Saldo' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={316} route={'/lancamento/controle-canteiro'} nome='Controle de Canteiro' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={20} route={'/lancamento/notas-entrada'} nome='Notas Fiscais de Entrada' handleNavigate={handleNavigate} />
                                <HeaderDropdown label='Pedidos' acessos={acessos}>
                                    <HeaderItem acesso={22} route={'/lancamento/gerenciamento-pedidos'} nome='Gerenciamento de Pedidos' handleNavigate={handleNavigate} />
                                    <HeaderItem acesso={248} route={'/lancamento/pedidos'} nome='Pedidos' handleNavigate={handleNavigate} />
                                </HeaderDropdown>
                            </HeaderDropdown>
                            <HeaderDropdown label='Questionários' acessos={acessos}>
                                <HeaderItem acesso={326} route={'/lancamento/questionarios/gerenciar-questionarios'} nome='Gerenciar Questionários' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={327} route={'/lancamento/questionarios/responder-questionarios'} nome='Responder Questionários' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                            <HeaderDropdown label='Sementeira' acessos={acessos}>
                                <HeaderItem acesso={336} route={'/lancamento/sementeira/controle-carga'} nome='Controle de Carga' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={346} route={'/lancamento/sementeira/pedidos-master'} nome='Pedidos Master' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={349} route={'/lancamento/sementeira/laboratorio'} nome='Laboratório' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                        </ul>
                    </div>
                    <div>
                        <button className='main-nav-button cb-dropdown'>
                            <i className='bi bi-pie-chart-fill me-1'></i>
                            Relatórios
                        </button>
                        <ul>
                            <HeaderItem acesso={329} route='/relatorio/curva-abc' nome='Curva ABC' handleNavigate={handleNavigate} />
                            <HeaderItem acesso={123} route='/relatorio/gerenciamento-datas' nome='Gerenciamento Datas' handleNavigate={handleNavigate} />
                            <HeaderDropdown label='Inventário' >
                                <HeaderItem acesso={72} route='/relatorio/inventario/acuracidade' nome='Acuracidade' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={313} route='/relatorio/inventario/dashboard' nome='Dashboard' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                            <HeaderItem acesso={184} route='/relatorio/layout' nome='Layout do Armazém' handleNavigate={handleNavigate} />
                            <HeaderDropdown label='Movimentação' >
                                <HeaderItem acesso={44} route='/relatorio/movimentacao/analitica' nome='Analítica' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={85} route='/relatorio/movimentacao/codbarra_lote' nome='Cód. Barras / Lote' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                            <HeaderDropdown label='Pedidos' >
                                <HeaderItem acesso={315} route='/relatorio/pedidos/acompanhamento' nome='Acompanhamento' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={312} route='/relatorio/pedidos/acompanhamento-balcao' nome='Acomp. Balcão' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={47} route='/relatorio/pedidos/situacao-pedidos' nome='Situação Pedidos' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                            <HeaderDropdown label='Produtos' >
                                <HeaderItem acesso={25} route='/relatorio/produtos/produtos' nome='Produtos' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={314} route='/relatorio/produtos/giro-de-estoque' nome='Giro de Estoque' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={97} route='/relatorio/produtos/saldo-estoque' nome='Saldo Estoque' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={179} route='/relatorio/produtos/saldo-historico' nome='Saldo Histórico' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                            <HeaderDropdown label='Questionários' >
                                <HeaderItem acesso={328} route='/relatorio/questionarios/respostas-usuario' nome='Respostas x Usuário' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                            <HeaderDropdown label='Sementeira' >
                                <HeaderItem acesso={344} route='/relatorio/sementeira/pedidos-master' nome='Pedidos Master' handleNavigate={handleNavigate} />
                                <HeaderItem acesso={350} route='/relatorio/sementeira/pedidos-master-itens' nome='Pedidos Master Itens' handleNavigate={handleNavigate} />
                            </HeaderDropdown>
                        </ul>
                    </div>
                    <div>
                        <button className='main-nav-button cb-dropdown'>
                            <i className='bi bi-lock-fill me-1'></i>
                            Segurança
                        </button>
                        <ul>
                            <HeaderItem acesso={295} route={'/seguranca/modulos'} nome='Módulos' handleNavigate={handleNavigate} />
                            <HeaderItem acesso={15} route={'/seguranca/perfis-acesso'} nome='Perfis Acesso' handleNavigate={handleNavigate} />
                        </ul>
                    </div>
                </nav>
                <div className='text-black exibicao-projeto-cd bg-light rounded-pill me-2 align-items-center d-flex' title={'Projeto: ' + (JSON.parse(sessionStorage.getItem('projeto'))?.nome_projeto || JSON.parse(sessionStorage.getItem('user'))?.nome_projeto) + '\nCD: ' + (JSON.parse(sessionStorage.getItem('cd'))?.nome_cd || JSON.parse(sessionStorage.getItem('user'))?.nome_cd)}>
                    <div className='online-indicator-container'>
                        <span className='online-indicator'></span>
                    </div>
                    <div className='d-flex w-100 text-truncate exibicao-projeto-cd-text d-lg-flex d-md-none d-sm-none d-xs-none px-2'>
                        {JSON.parse(sessionStorage.getItem('cd'))?.nome_cd || JSON.parse(sessionStorage.getItem('user'))?.nome_cd}
                    </div>
                </div>
                <Impressao />
                <Notificacoes />
                <div className='btn-group dropdown'>
                    <button className='btn btn-light dropdown-toggle pt-1 pb-1' type='button' id='user-header-actions' data-bs-toggle='dropdown' aria-expanded='false'>
                        <i className='bi bi-person-fill me-1'></i>
                        {String(JSON.parse(sessionStorage.getItem('user')).login).split('').reduce((accumulator, elem, index) => accumulator + (index === 0 ? elem.toUpperCase() : elem.toLowerCase()), '')}
                    </button>
                    <ul className='dropdown-menu dropdown-menu-end mt-1 p-0 rounded-0' aria-labelledby='user-header-actions'>
                        <li><a role='button' className={`dropdown-item py-1 px-2 ${sessionStorage.getItem('qtd_cds') === '1' ? 'disabled' : ''}`} data-bs-toggle='modal' data-bs-target='#mudar-cd-modal' onClick={handleClickChangeCd} >Mudar de CD</a></li>
                        <li><a role='button' className={`dropdown-item py-1 px-2 ${!sessionStorage.getItem('projeto') ? 'disabled' : ''}`} data-bs-toggle='modal' data-bs-target='#mudar-projeto-modal' onClick={handleClickChangeProjeto}>Mudar projeto</a></li>
                        <li><a role='button' className='dropdown-item py-1 px-2' onClick={goLogin}>Sair</a></li>
                    </ul>
                </div>
            </header>
        </>
    );
}

export default Header;